export default __webpack_public_path__ + "static/media/science.0e480cba.svg";